import { useAuth } from "@/context/AuthContext";
import PricingCards from "@/components/PricingCards";
import { SubscriptionManager } from "@/components/SubscriptionManager";
import { CheckCircle, Clock } from "@phosphor-icons/react";

const PLAN_LABEL = { monthly: "Mensuel", annual: "Annuel", lifetime: "À vie", mission_express: "Mission Express" };
const planLabel = (plan, lookup) => plan === "standard"
  ? (lookup === "interko_standard_365" ? "Annuel (offre historique)" : "Offre Unique — 29 €/mois")
  : (PLAN_LABEL[plan] || plan);

export default function Billing() {
  const { user } = useAuth();
  const ent = user?.entitlements || {};
  const active = ent.is_paid;
  const planName = user?.organization?.plan || user?.plan;
  const lookup = user?.organization?.billing_lookup_key;

  return (
    <div>
      <div className="overline mb-2">Abonnement</div>
      <h1 className="font-display text-3xl font-bold mb-6">Votre abonnement interKO</h1>

      <div className="surface rounded-lg p-6 mb-8 max-w-2xl" data-testid="subscription-status">
        <div className="flex items-center gap-4">
          <div className={`w-12 h-12 rounded-md flex items-center justify-center ${active ? "bg-accent/15 border border-accent/30" : "bg-surface-2 border border-border"}`}>
            {active ? <CheckCircle size={26} className="text-accent" weight="fill" /> : <Clock size={24} className="text-muted" />}
          </div>
          <div className="flex-1">
            {active ? (
              <>
                <div className="font-display text-lg font-bold text-fg" data-testid="billing-plan-name">Plan {planLabel(planName, lookup)} actif</div>
                <div className="text-sm text-muted">Accès complet · toutes les fonctionnalités incluses</div>
              </>
            ) : (
              <>
                <div className="font-display text-lg font-bold text-fg">Aucun abonnement actif</div>
                <div className="text-sm text-muted">Abonnez-vous à interKO pour accéder à la plateforme.</div>
              </>
            )}
          </div>
        </div>
        {active && <SubscriptionManager />}
      </div>

      {!active && (
        <div className="max-w-2xl mb-6">
          <h2 className="font-display text-2xl font-bold mb-2">Abonnez-vous à interKO</h2>
          <p className="text-muted text-sm">29 €/mois. Sans engagement, résiliable à tout moment. Toutes les opportunités de mission.</p>
        </div>
      )}
      {!active && <PricingCards />}
    </div>
  );
}
